import { render } from "./SeaRef.vue?vue&type=template&id=732dd83c&scoped=true"
import script from "./SeaRef.vue?vue&type=script&lang=js"
export * from "./SeaRef.vue?vue&type=script&lang=js"

import "./SeaRef.vue?vue&type=style&index=0&id=732dd83c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732dd83c"]])

export default __exports__